import SectionHeading from './SectionHeading';
import { oldReview } from '@/mocks/material';

export default function OldReview() {
  return (
    <section
      id="oldreview"
      className="scroll-mt-24 border-y border-background-200/80 bg-background-100/50"
    >
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          index="04"
          kicker="旧料回顾"
          title="回过味来的大瓜，才值得再看一遍"
          desc="当年看一热闹，如今回看补料才发现漏了多少层。这里把过往大瓜按年度归档，每份都标注原始年份与事后再补的线索。"
          linkText="看全部往年事件"
        />

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {oldReview.map((o) => (
            <article
              key={o.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-secondary-300"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={o.image}
                  alt={o.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-sm bg-background-950/80 px-2 py-0.5 text-[11px] font-semibold text-background-100">
                  {o.year}
                </span>
                <span className="absolute right-3 top-3 rounded-sm bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-700">
                  {o.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col justify-between gap-4 p-4 md:p-5">
                <div>
                  <h3 className="font-heading text-[15px] font-bold leading-snug text-foreground-950">
                    {o.title}
                  </h3>
                  <p className="mt-2 text-xs leading-6 text-foreground-600">{o.excerpt}</p>
                </div>
                <button
                  type="button"
                  className="inline-flex items-center gap-1.5 self-start text-xs font-semibold text-secondary-700 hover:text-secondary-800"
                >
                  回翻这份旧料
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}